import React, { useState, useEffect } from "react";
import tokens from "../../../../utils/token";
import "./ClientAuthStyles.css";
import ClientsQueries from "../../../../requests/queries/ClientsQueries";
import LoadingSpinner from "../../../common/Loading";

const ClientAuth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    const formData = {
      email: event.target.email.value,
      password: event.target.password.value
    };

    const query = isLogin ? ClientsQueries.login(formData) : ClientsQueries.register(formData);

    query
      .then((res) => {
        if(res.data.token) {
          tokens.client_token.setToken(res.data.token);
          window.location.href = '/shop';
        } else {
          setError(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError(err.response?.data?.message || 'An error occurred');
      });
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setError(null);
  };

  const isClientAuthenticated = async () => {
    const token = await tokens.client_token.getToken();
    if(token){
      const res = await ClientsQueries.isAuthenticated();
      if(res){
        window.location.href = '/shop';
      }else{
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    isClientAuthenticated();
  }, []);

  if(isLoading){
    return <LoadingSpinner />;
  }

  return (
    <div className="auth-container">
      <div className="logo-container">
        <img 
          src="/patricians.png" 
          alt="Patricians Logo" 
          className="logo-image"
        />
      </div>
      
      <div className="auth-card mb-5">
        <div className="auth-switch">
          <button 
            className={`switch-btn ${isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(true)}
          >
            LOGIN
          </button>
          <button 
            className={`switch-btn ${!isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(false)}
          >
            REGISTER
          </button>
        </div>

        <h2 className="auth-title">
          {isLogin ? 'CLIENT LOGIN' : 'CLIENT REGISTER'}
        </h2>
        <p className="auth-subtitle">
          {isLogin ? 'Sign in to your client account' : 'Create your client account'}
        </p>
        <a href="/reset-password" className="auth-link-reset-password">Forgot password?</a>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input 
              type="email" 
              className="form-control" 
              id="email" 
              name="email" 
              placeholder={isLogin ? "Enter your email" : "Your email address"}
              required 
            />
          </div>
          
          <div className="mb-4">
            <label htmlFor="password" className="form-label">Password</label>
            <input 
              type="password" 
              className="form-control" 
              id="password" 
              name="password" 
              placeholder={isLogin ? "Enter your password" : "Create a password"}
              required 
            />
          </div>
          
          {
            !isLogin && (
              <div className="mb-4">
                <label htmlFor="confirm-password" className="form-label">Confirm password</label>
                <input 
                  type="password" 
                  className="form-control" 
                  id="confirmPassword" 
                  name="confirmPassword" 
                  placeholder="Confirm your password"
                  required 
                />
              </div>
            )
          }
          
          <button disabled={isLoading} type="submit" className="btn btn-auth">
            {isLoading 
              ? (isLogin ? 'Signing in...' : 'Registering...') 
              : (isLogin ? 'Sign in' : 'Create account')
            }
          </button>
          
          {error && <div className="error-message mt-3 mb-3">{error}</div>}
        </form>
        
        <div className="auth-link-container">
          <span className="auth-link-text">
            {isLogin ? "Don't have an account?" : "Already have an account?"}
          </span>
          <button 
            type="button" 
            className="auth-link-btn"
            onClick={toggleMode}
          >
            {isLogin ? "Create account" : "Sign in"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientAuth;